import config from 'lib/config';
import { LeadsResponse } from 'types/Apis/Lead';
import authorizedFetch from 'lib/authorizedFetch';

async function fetchLeads(): Promise<LeadsResponse> {
  return authorizedFetch(`${config.coreApiUrl}/api/current_user/leads`);
}

export default fetchLeads;
